import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { convertSecsToWords } from "utils";
import { toggleScheduleInterval } from "store/actions";
import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";

function Interval(props) {
  return (
    <div className="intervel flex_align">
      <p>Set backup interval:</p>
      <div className="main_select">
        <select
          onChange={e => props.toggleScheduleInterval(e.target.value)}
          value={props.interval.selected}
        >
          {props.interval.values.map((val, i) => (
            <option key={i} value={val}>
              {convertSecsToWords(val)}
            </option>
          ))}
        </select>
      </div>
      <Tooltip {...TOOLTIPS.backupSettings.schedule.interval}>
        <span className="icon">
          <InformationIcon />
        </span>
      </Tooltip>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    interval: state.backupSettings.scheduleInfo.interval
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleScheduleInterval
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Interval);
